(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _ui = require('./modules/ui.js');

var _ui2 = _interopRequireDefault(_ui);

var _works = require('./modules/works.js');

var _works2 = _interopRequireDefault(_works);

var _contact = require('./modules/contact.js');

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(document).ready(function () {
  (0, _ui2.default)();
  (0, _works2.default)();
  (0, _contact2.default)();
});

},{"./modules/contact.js":2,"./modules/ui.js":3,"./modules/works.js":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = contact;
function contact() {

	// Variables

	var send_button = $('#sendmsg button');

	// Email JS init

	emailjs.init("user_oLSfdYi3FPUnn5ipPzusf");

	// Respond

	function respond(status) {
		if (status == "wait") var response = "<span class='icon-spin2'></span> Send message";
		if (status == "success") var response = "<span class='icon-ok'></span> Message Sent";
		if (status == "error") var response = "<span class='icon-cancel'></span> Error";
		send_button.html(response);
	}

	// Send

	function send() {

		var from_name = $("#name").val();
		var from_mail = $("#mail").val();
		var message = $("#msg").val();
		var body = from_name + ' ===== ' + from_mail + ' ===== ' + message;

		respond('wait');

		if (from_name != "undefined" && from_mail != "undefined" && message != "undefined") {
			emailjs.send("gmail", "emails_from_github", { msg: body }).then(function (response) {
				respond('success');
			}, function (err) {
				respond('error');
				console.log("FAILED. error=", err);
			});
		}
	}

	// Validate / Submit

	$('#sendmsg').parsley().on('field:validated', function () {
		var ok = $('.parsley-error').length === 0;
		$('.bs-callout-info').toggleClass('hidden', !ok);
		$('.bs-callout-warning').toggleClass('hidden', ok);
	}).on('form:submit', function () {
		send();
	});

	// Send button prevent default

	send_button.click(function (e) {
		e.preventDefault();
		send();
	});
}

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ui;
function ui() {
  var _this = this;

  // Show my age

  function calculateAge(dateString) {
    var birthday = +new Date(dateString);
    return ~~((Date.now() - birthday) / 31557600000);
  }

  $('#age').text(calculateAge('1990-05-30'));

  // Show current year

  $('#year').text(new Date().getFullYear());

  // Contact form lines animation

  $('input, textarea').focusin(function () {
    $(_this).parent().addClass('active');
  }).focusout(function () {
    $(_this).parent().removeClass('active');
  });

  // Smooth scroll to div

  $('header li a').click(function () {

    var shift = 0;
    var target = $(this).attr('href');

    if (target == "#contact") shift = 240;
    if (target == "#works") shift = 12;

    $('html, body').animate({
      scrollTop: $(target).offset().top + shift
    }, 500);
  });

  // Wow

  new WOW().init();
}

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = works;
function works() {

	// Masonry

	var container = document.querySelector('.works');

	var msnry = new Masonry(container, {
		itemSelector: '.works-item'
	});

	// Placeholders -> Previews -> Images

	[].forEach.call(document.querySelectorAll('.placeholder'), function (el) {

		var preview = el.querySelector('.preview'),
		    img = new Image(),
		    imgLarge = new Image();

		// Show preview

		img.src = preview.src;

		img.onload = function () {
			preview.classList.add('preview_loaded');
		};

		// Show large image

		imgLarge.src = el.dataset.large;

		imgLarge.onload = function () {
			imgLarge.classList.add('large_loaded');
		};
		el.appendChild(imgLarge);
	});
}

},{}]},{},[1])
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
